import React, { useEffect, useState } from "react";
import { get } from "../../../../utils/api";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import CardMonthYearPicker from "../../../../Components/Common/CardMonthPicker";
import {
  fixedTons,
  formatNumberCommaSeparated,
} from "../../../../utils/common";

const OffroadCard = ({ list = [] }) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [cardBannerData, setCardBannerData] = useState(null);
  const [selectedFuel, setSelectedFuel] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  useEffect(() => {
    if (list.length > 0 && !selectedFuel) {
      setSelectedFuel(list[0] || "");
    }
    console.log("select", selectedFuel);
  }, [list, selectedFuel]);

  useEffect(() => {
    if (!selectedFuel) return;
    const fetchCardData = async () => {
      try {
        const response = await get(
          `/scope1/mobileCombustion/ofRoadcardData?${new URLSearchParams({
            year: selectedYear,
            month: selectedMonth,
            fuelType: selectedFuel,
          }).toString()}`
        );
        setCardBannerData(response?.data?.data || null);
      } catch (error) {
        setCardBannerData(null);
      }
    };

    fetchCardData();
  }, [selectedMonth, selectedYear, selectedFuel]);

  return (
    <>
      <p
        style={{
          fontWeight: "700",
          fontSize: "22px",
          color: "#001632",
          fontFamily: "Inter",
          textDecoration: "underline",
          marginTop: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        Mobile Combustion
      </p>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          justifyContent: "space-between",
        }}
      >
        <InfoCard title="Total Fuel Consumption">
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: "1" }}
          >
            <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
              Total Fuel Consumed
            </Typography>
            <Select
              size="small"
              sx={{
                fontSize: "14px",
                height: 30,
                minWidth: "10rem",
                width: "10rem",
                ml: "0.5rem",
              }}
              value={selectedFuel}
              onChange={(e) => setSelectedFuel(e.target.value)}
              displayEmpty
            >
              <MenuItem value="" sx={{ fontSize: "14px" }} disabled>
                Select
              </MenuItem>
              {list.map((option, idx) => (
                <MenuItem key={idx} value={option} sx={{ fontSize: "14px" }}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#555", mt: 1 }}
          >
            {formatNumberCommaSeparated(
              fixedTons(cardBannerData?.total?.[0]?.totalQuantityConsumed ?? 0)
            )}{" "}
            {cardBannerData?.total?.[0]?.unit || ""}
          </Typography>
        </InfoCard>

        <InfoCard title="Top Fuel Consumption Machinery">
          <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
            Top Fuel Consumption Machinery (Type of Fuel)
          </Typography>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#555", mt: 1 }}
          >
            {cardBannerData?.machinary?.length
              ? cardBannerData.machinary.map((item) => item.name).join(" | ")
              : "N/A"}
          </Typography>
        </InfoCard>

        <InfoCard title="Consumption Month">
          <Box
            sx={{
              display: "flex",
              gap: "0.5rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
              Consumption Month
            </Typography>
            <CardMonthYearPicker
              {...{
                setSelectedMonth,
                setSelectedYear,
                selectedMonth,
                selectedYear,
                defaultMonth: currentMonth,
                defaultYear: currentYear,
                // width: "10px",
                gap: "0.3rem",
              }}
            />
          </Box>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#555", mt: 1 }}
          >
            {formatNumberCommaSeparated(
              fixedTons(
                cardBannerData?.monthly?.[0]?.totalQuantityConsumed ?? 0
              )
            )}{" "}
            {cardBannerData?.monthly?.[0]?.unit || ""}
          </Typography>
        </InfoCard>
      </Box>
    </>
  );
};

const InfoCard = ({ title, children }) => (
  <Box
    sx={{
      backgroundColor: "#FCFCFC",
      borderRadius: "12px",
      padding: "1.25rem",
      boxShadow: "rgba(0, 0, 0, 0.15)",
      width: "32%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "10rem",
    }}
  >
    {children}
  </Box>
);

export default OffroadCard;
